"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadingTag = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const hi_1 = require("react-icons/hi");
function HeadingTag(_a) {
    var { customId, headingType, headingText, linkUrl, linkText, linkTarget, linkArrowOn = true, visuallyHidden = false, linkClassName, linkProps } = _a, props = __rest(_a, ["customId", "headingType", "headingText", "linkUrl", "linkText", "linkTarget", "linkArrowOn", "visuallyHidden", "linkClassName", "linkProps"]);
    return (react_1.default.createElement("div", Object.assign({}, props, { className: (0, classnames_1.default)('w-full max-w-screen-2xl mx-auto px-4', {
            'flex justify-start flex-wrap items-center gap-x-4': linkUrl && linkText,
            'sr-only': visuallyHidden,
        }, props === null || props === void 0 ? void 0 : props.className) }),
        headingType === 'H1' && (react_1.default.createElement("h1", { id: customId, className: (0, classnames_1.default)('font-sofia font-semibold text-2xl md:text-[32px] leading-normal') }, headingText)),
        headingType === 'H2' && (react_1.default.createElement("h2", { className: (0, classnames_1.default)('font-sofia font-semibold text-xl md:text-2xl') }, headingText)),
        headingType === 'H3' && (react_1.default.createElement("h3", { className: (0, classnames_1.default)('font-sofia font-semibold text-lg md:text-xl') }, headingText)),
        headingType === 'H4' && (react_1.default.createElement("h4", { className: (0, classnames_1.default)('font-sofia font-semibold text-lg') }, headingText)),
        headingType === 'H5' && (react_1.default.createElement("h5", { className: (0, classnames_1.default)('font-sofia text-base') }, headingText)),
        headingType === 'H6' && (react_1.default.createElement("h6", { className: (0, classnames_1.default)('font-sofia text-sm') }, headingText)),
        linkUrl && linkText && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", Object.assign({ href: linkUrl, target: linkTarget, rel: linkTarget === '_blank' ? 'noreferrer' : '', className: (0, classnames_1.default)('pt-2 pb-1 align-middle link inline-block', linkClassName) }, linkProps),
                react_1.default.createElement("span", { className: (0, classnames_1.default)({
                        'mr-2': linkArrowOn,
                    }) }, linkText),
                linkArrowOn && (react_1.default.createElement(hi_1.HiArrowRight, { "aria-hidden": true, className: "inline-block relative -top-0.5" })))))));
}
exports.HeadingTag = HeadingTag;
